import React from "react";
import { NavLink } from "react-router-dom";
import { teamMembersDetails } from "./../../data/index";
var bgimg1 = require("./../../images/background/bg-image.png");
let charlieImg = require("./../../images/our-team5/charlie.jpg");

class Team1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full p-t80 p-b80 mobile-page-padding bg-cream"
          style={{
            backgroundImage: "url(" + bgimg1 + ")",
            backgroundRepeat: "no-repeat",
            objectFit: "fill",
          }}
        >
          <div className="container-fluid">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-moving bg-repeat-x"
                  style={{ backgroundColor: "#22333B" }}
                >
                  <h3 className="sep-line-one">Our Team </h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            {/* IMAGE CAROUSEL START */}
            <div className="section-content">
              <div
                className="row team-item-four"
                style={{ marginLeft: "30px", marginRight: "30px" }}
              >
                {teamMembersDetails.map((item, index) => (
                  <div className="col-lg-3 col-md-3 col-sm-6 m-b30" key={index}>
                    <div className="our-team-2 ">
                      <div className="profile-image">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="figcaption scroll-desc text-black">
                        <h4 className="m-t0 mb-0">{item.membername}</h4>
                        {/* <span  >{item.position}</span> */}
                        <p className="mt-2">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="col-lg-4 col-md-3 col-sm-6 m-b30"></div>

                <div className="col-lg-4 col-md-3 col-sm-6 m-b30">
                  <div className="our-team-2 ">
                    <div className="profile-image">
                      <img src={charlieImg} alt="" />
                    </div>
                    <div className="figcaption scroll-desc text-black">
                      <h4 className="m-t0 mb-0">Charlie</h4>
                      {/* <span  >{item.position}</span> */}
                      <p className="mt-2">
                        Meet Charlie, our lovable Chief Happiness Officer! With
                        his wagging tail and endless enthusiasm, Charlie brings
                        a spark of joy to every event. He keeps the team in high
                        spirits, his playful energy is the heart and soul of
                        Sunlight Creationz.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-3 col-sm-6 m-b30"></div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Team1;
